var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEyePassword(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 18,
    viewBox: "0 0 22 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.48593 14.129C3.64093 12.819 2.18093 11.115 1.35593 10.039C1.12523 9.74198 1 9.37659 1 9.0005C1 8.62441 1.12523 8.25902 1.35593 7.962C2.84893 6.013 6.43093 2 10.6129 2C12.4889 2 14.2429 2.807 15.7429 3.874",
    stroke: "#273B4A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.61328 15.704C9.26249 15.8972 9.93593 15.9969 10.6133 16C14.7953 16 18.3773 11.987 19.8703 10.038C20.1009 9.74071 20.226 9.37509 20.2258 8.99883C20.2256 8.62256 20.1002 8.25707 19.8693 7.96C19.3446 7.27549 18.7817 6.62112 18.1833 6M12.7433 6.887C12.4656 6.60467 12.1347 6.38011 11.7698 6.22629C11.4049 6.07246 11.0131 5.99241 10.6171 5.99075C10.2211 5.98909 9.82863 6.06586 9.46243 6.21662C9.09623 6.36738 8.7635 6.58916 8.48344 6.86915C8.20338 7.14915 7.98152 7.48183 7.83067 7.84799C7.67983 8.21416 7.60297 8.60657 7.60453 9.00259C7.6061 9.3986 7.68606 9.79039 7.8398 10.1554C7.99354 10.5203 8.21801 10.8512 8.50028 11.129L12.7433 6.887ZM2.61328 17L18.6133 1L2.61328 17Z",
    stroke: "#273B4A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyePassword);
export default __webpack_public_path__ + "static/media/Eye_password.93d55cb0826bc977ee86b08e92522698.svg";
export { ForwardRef as ReactComponent };